module.exports = __webpack_public_path__ + "img/banner3.4fd4f9fc.png";